/**
 * Payment Cancel Page
 * LOT 4 - Système de Paiement Stripe
 * 
 * Page affichée après annulation du paiement
 */
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { XCircle, ArrowLeft, RefreshCw, Home } from 'lucide-react';

const PaymentCancelPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="bg-[#0F0F0F] border-[#C9A24D]/20">
          <CardContent className="p-6">
            <div className="text-center py-8">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-orange-500/20 mb-6">
                <XCircle className="w-10 h-10 text-orange-400" />
              </div>
              
              <h2 className="text-2xl font-['Playfair_Display'] text-[#E5E5E5] mb-2">
                Paiement annulé
              </h2>
              <p className="text-[#E5E5E5]/60 mb-6">
                Vous avez annulé le paiement. Votre réservation n'a pas été confirmée.
              </p>

              {bookingId && (
                <p className="text-sm text-[#E5E5E5]/40 mb-6">
                  Référence: <span className="font-mono text-[#C9A24D]">{bookingId}</span>
                </p>
              )}

              <div className="p-4 bg-[#1F1F1F] border border-[#E5E5E5]/10 rounded-lg text-sm text-[#E5E5E5]/60 mb-6 text-left">
                <p className="mb-2">Votre réservation est toujours enregistrée avec le statut <strong>"En attente de paiement"</strong>.</p>
                <p>Vous pouvez reprendre le paiement à tout moment.</p>
              </div>

              <div className="flex flex-col gap-3">
                <Button
                  onClick={() => navigate('/booking')}
                  className="w-full bg-[#C9A24D] hover:bg-[#E6C77A] text-[#0B0B0B] font-semibold"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Nouvelle réservation
                </Button>
                
                <Button
                  variant="outline"
                  onClick={() => navigate('/')}
                  className="w-full border-[#E5E5E5]/20 text-[#E5E5E5] hover:bg-[#E5E5E5]/5"
                >
                  <Home className="w-4 h-4 mr-2" />
                  Retour à l'accueil
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
